<!--<div class="row">
    <div class="col-24">
        <h4><u>Section 2: To Enroll in SilverScript Prescription Drug Plan</u></h4>
    </div>
</div>-->
<div class="row">
    <div class="col-8">
        <div class="input-wrapper bottom-20">
            <div *ngIf="enrollmentDrugViewModel.ISSINGLEGROUP;else other_content">
                <ValidatedTextField [label]="'Desired Plan'"
                                    [text]="enrollmentDrugViewModel.SINGLEGRPNAME"
                                    [disabled]="'true'">
                </ValidatedTextField>
            </div>
            <ng-template #other_content>
                <ValidatedRadioButtonGroup [label]="'Desired Plan'"
                                           [options]="optionrbPlan"
                                           [selectedValue]="enrollmentDrugViewModel.PLANTYPE"
                                           [disabled]="disabled"
                                           (onValueChange)="onPlanChange($event)"
                                           [radioGroupName]="'Plan'">
                </ValidatedRadioButtonGroup>
            </ng-template>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8" *ngIf="enrollmentDrugViewModel.FORMNAME !== formValue">
        <div class="input-wrapper">
            <label>Application Received Date</label>
            <JQDatePicker [selectedDate]="enrollmentDrugViewModel.APPDT"
                          (elementClicked)="appRecievedDateChange($event)"
                          [disabled]="disableAppRecievDt">
            </JQDatePicker>
            <!--<ValidatedDateTextField [label]="'Application Date'"
                                    [date]="enrollmentDrugViewModel.APPDT"
                                    [disabled]="disabled"
                                    (onDateChange)="updateInfo('APPDT', $event)"
                                    [validators]="[validatedDate,notBlankValidator]">
            </ValidatedDateTextField>-->
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <label>Effective Date of Enrollment</label>
            <JQDatePicker [selectedDate]="enrollmentDrugViewModel.EFFDT"
                          (elementClicked)="enrollmentDrugViewModel.EFFDT = $event"
                                    [disabled]="disableEffectiveDate">
            </JQDatePicker>
            <!--<ValidatedDateTextField [label]="'Effective Date of Enrollment'"
                                    [date]="enrollmentDrugViewModel.EFFDT"
                                    [disabled]="disabled"
                                    (onDateChange)="updateInfo('EFFDT', $event)"
                                    [validators]="[validatedDate,notBlankValidator]">
            </ValidatedDateTextField>-->
        </div>
    </div>
</div>
